import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { EventsSection } from "@/components/home/Sections";

export default function EventsPage() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] pt-[72px]" data-testid="events-page">
      <SiteHeader />
      <EventsSection limit={30} />
      <SiteFooter />
    </div>
  );
}
